import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import reducers, { rootSaga } from './reducers';

const logger = createLogger();

const sagaMiddleware = createSagaMiddleware();

const store = createStore(reducers, process.env.NODE_ENV === 'production' ?
    applyMiddleware(sagaMiddleware) :
    applyMiddleware(logger, sagaMiddleware));
sagaMiddleware.run(rootSaga)

export default store;